<script>
import axios from 'axios';
import Grid from './pages/Grid.vue';

export default {
    name: 'ProductIconsCarousel',
    components: { Grid },
    data() {
        return {
            grid: {},
        };
    },
    async mounted() {
        try {
            const client = axios.create();

            const response = await client
                .get('https://content.bubblegumballoons.com/items/grids/b2d5f1c8-70f8-45ad-adb8-1861ae8a3b06', {
                    params: {
                        fields: [
                            '*',
                            'items.*',
                            'items.components.*',

                            // Images
                            'items.components.item:images.*',
                            'items.components.item:images.sizes.*',
                            'items.components.item:images.sizes.directus_files_id.*',

                            // Markdown
                            'items.components.item:markdown.*',

                            // Buttons
                            'items.components.item:buttons.*',

                            // Carousel
                            'items.components.item:carousels.*',
                            'items.components.item:carousels.slides.*',
                            'items.components.item:carousels.slides.components.*',
                            'items.components.item:carousels.slides.background.*',
                            'items.components.item:carousels.slides.background.sizes.*',
                            'items.components.item:carousels.slides.background.sizes.directus_files_id.*',
                            'items.components.item:carousels.slides.components.item:images.*',
                            'items.components.item:carousels.slides.components.item:images.sizes.*',
                            'items.components.item:carousels.slides.components.item:images.sizes.directus_files_id.*',
                            'items.components.item:carousels.slides.components.item:markdown.*',
                            'items.components.item:carousels.slides.components.item:buttons.*',
                            'items.components.item:carousels.slides.components.item:links.*',
                            'items.components.item:carousels.slides.components.item:links.link_items.*',
                            'items.components.item:carousels.slides.components.item:videos.*',

                            // Product grids
                            'items.components.item:product_grids.*',

                            // Links
                            'items.components.item:links.*',
                            'items.components.item:links.link_items.*',

                            // Videos
                            'items.components.item:videos.*',

                            // Help Categories
                            'items.components.item:help_categories.*',
                            'items.components.item:help_categories.articles.articles_id.*',
                        ],
                    },
                });

            this.grid = response.data?.data || {};
        } catch (e) {
            // Ignore
        }
    },
};
</script>

<template>
    <Grid :grid="grid" />
</template>

<style scoped lang="scss">

</style>
